import LiquidityMining from '~/components/LiquidityMining'
import i18n from '~/i18n'
import { HOST } from '~/constants/host'

export const getStaticProps = async () => {
  const t = i18n.t

  return {
    props: {
      openGraphData: [
        {
          property: 'og:url',
          content: `${HOST}/lon/mining/lp`,
          key: 'ogurl',
        },
        {
          property: 'og:title',
          content: t('meta_lon_liquidity_title'),
          key: 'ogtitle',
        },
        {
          property: 'og:description',
          content: t('meta_lon_liquidity_description'),
          key: 'ogdesc',
        },
      ],
    },
  }
}

export default LiquidityMining
